import { Injectable } from '@angular/core';
import { SeverityLevel } from '@microsoft/applicationinsights-web';
import { AppInsightsService } from '../app-insights/app-insights.service';
@Injectable({
    providedIn: 'root'
})
export class LoggingService {
    constructor(private appInsights: AppInsightsService) {}

    logCritical(error: any): void {
        this.appInsights.logException(error, SeverityLevel.Critical);
    }

    logError(error: any): void {
        this.appInsights.logException(error, SeverityLevel.Error);
    }

    logWarning(error: any): void {
        this.appInsights.logException(error, SeverityLevel.Warning);
    }

    logInformation(error: any): void {
        this.appInsights.logException(error, SeverityLevel.Information);
    }

    logVerbose(error: any): void {
        this.appInsights.logException(error, SeverityLevel.Verbose);
    }

    // Message logging methods
    logMessageCritical(message: string, properties?: Record<string, any>): void {
        this.appInsights.logMessage(message, SeverityLevel.Critical, properties);
    }

    logMessageError(message: string, properties?: Record<string, any>): void {
        this.appInsights.logMessage(message, SeverityLevel.Error, properties);
    }

    logMessageWarning(message: string, properties?: Record<string, any>): void {
        this.appInsights.logMessage(message, SeverityLevel.Warning, properties);
    }

    logMessageInformation(message: string, properties?: Record<string, any>): void {
        this.appInsights.logMessage(message, SeverityLevel.Information, properties);
    }

    logMessageVerbose(message: string, properties?: Record<string, any>): void {
        this.appInsights.logMessage(message, SeverityLevel.Verbose, properties);
    }

    logEvent(name: string, properties?: Record<string, any>): void {
        this.appInsights.logEvent(name, properties);
    }
}
